import React, {useEffect, useMemo, useState} from 'react'
import {connect} from "react-redux";
import {buy, cleanPurchase} from "../../redux/actions/carrito";
import {toast} from 'react-toastify';
import ItemCartProductInfo from "../../widgets/item_cart_product_info";
import Swal from 'sweetalert2';
import {useNavigate} from "react-router-dom";
import ButtonBack from "../../widgets/button_back";
import ButtonNext from "../../widgets/button_next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboardCheck, faShieldHalved} from "@fortawesome/free-solid-svg-icons";

function Part4({buy, next, carrito_redux, user, location, saled, cleanPurchase, data_payment, store_id}) {
    const navigate = useNavigate();
    const [carrito, setCarrito] = useState(carrito_redux);

    useEffect(() => {
        if (saled) {

        }
    }, [saled]);


    const subTotal = useMemo(() => {
        return carrito.reduce((acc, producto) => {
            let price = producto.price;
            if (producto.has_offer) {
                price = producto.offer_price;
            }
            return acc + price * producto.quantity;
        }, 0);
    }, [carrito]);

    const totalItems = useMemo(() => {
        return carrito.reduce((acc, p) => acc + p.quantity, 0);
    }, [carrito]);

    const volver = () => {
        next(2);
    }
    const siguiente = async () => {
        let products = carrito.map((item) => {
            return {
                variant_id: item.variant_id,
                has_offer: item.has_offer,
                price: item.price,
                offer_price: item.offer_price,
                quantity: item.quantity
            }
        });
        let data_entrega = JSON.parse(localStorage.getItem('data_entrega')) ?? '';

        let data = {
            'products': JSON.stringify(products),
            'client_id': user.id,
            'payment_method_id': data_payment.payment_method_id,
            'delivery_method_id': data_payment.delivery_method_id,
            'name': data_entrega.name,
            'email': data_entrega.email,
            'phone': data_entrega.phone,
            'invoice_id': localStorage.getItem('invoice_id'),
            'store_id': store_id,
        };
        const success = await buy(data);
        if (success) {
            await Swal.fire({
                title: 'Éxito!',
                text: "La solicitud fue realizada exitosamente",
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#0049a8',
                cancelButtonColor: '#e5e7eb',
                cancelButtonText: ' ← Ir a inicio',
                confirmButtonText: ' Ir a listado de solicitud! →',
                reverseButtons: true,
                allowEscapeKey: false,
                backdrop: true,
                allowOutsideClick: false
            }).then((result) => {
                cleanPurchase();
                if (result.isConfirmed) {
                    navigate('/dashboard/compras');
                }
                if (result.isDismissed) {
                    navigate('/');
                }
            });
        } else {
            toast.error("No se pudo realizar la solicitud. Intenta de nuevo.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            Swal.fire({
                icon: 'error',
                title: 'Oops!',
                text: "No se pudo realizar la solicitud. Intenta de nuevo...",
                confirmButtonColor: '#000000',
            })
        }
    }

    return (
        <>
            <main className="w-full min-h-screen bg-gray-50">
                <div className="container mx-auto px-3 md:px-6 py-6 md:py-8">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">

                        {/* Order Items */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                {/* Header */}
                                <div className="px-5 md:px-6 pt-5 md:pt-6 pb-4 border-b border-gray-100">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                                            <FontAwesomeIcon icon={faClipboardCheck} className="text-ecoprimary1"/>
                                        </div>
                                        <div>
                                            <h2 className="text-xl font-bold text-gray-900">Confirma tu pedido</h2>
                                            <p className="text-sm text-gray-500">Revisa los productos antes de solicitar</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Products List (read-only) */}
                                <div className="px-4 md:px-6 py-4 max-h-[60vh] md:max-h-[65vh] overflow-y-auto space-y-3">
                                    {carrito.map((product, index) =>
                                        <ItemCartProductInfo product={product} key={index}/>
                                    )}
                                </div>

                                <div className="px-5 md:px-6 py-4 border-t border-gray-100">
                                    <ButtonBack onClick={volver} label="← Volver"/>
                                </div>
                            </div>
                        </div>

                        {/* Summary */}
                        <div className="lg:col-span-1">
                            <div className="lg:sticky lg:top-24">
                                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                    <div className="px-5 md:px-6 pt-5 md:pt-6 pb-4 border-b border-gray-100">
                                        <h2 className="text-lg font-bold text-gray-900">Resumen final</h2>
                                    </div>

                                    <div className="px-5 md:px-6 py-5">
                                        <div className="flex justify-between items-center py-3">
                                            <span className="text-sm text-gray-500">Subtotal ({totalItems} productos)</span>
                                            <span className="text-sm font-semibold text-gray-700">Bs {subTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between items-center py-3 border-b border-gray-100">
                                            <span className="text-sm text-gray-500">Envío</span>
                                            <span className="text-sm font-medium text-gray-400">Coordinación interna</span>
                                        </div>

                                        <div className="flex justify-between items-center py-4">
                                            <span className="text-base font-bold text-gray-900">Total</span>
                                            <span className="text-2xl font-bold text-ecoprimary1">Bs {subTotal.toFixed(2)}</span>
                                        </div>

                                        <ButtonNext
                                            className="w-full mt-2 !py-3.5 !text-base"
                                            onClick={siguiente}
                                            label="Solicitar pedido →"
                                        />

                                        {/* Security badge */}
                                        <div className="flex items-center justify-center gap-2 mt-4 text-xs text-gray-400">
                                            <FontAwesomeIcon icon={faShieldHalved} className="text-green-500"/>
                                            <span>Solicitud segura y protegida</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

const mapStateToProps = state => ({
    saled: state.Cart.saled,
    carrito_redux: state.Cart.carrito,
    store_id: state.Cart.store_id,
    user: state.Auth.user,
    location: state.Location.location,
    data_payment: state.Payment.data_payment,
})

export default connect(mapStateToProps, {
    buy, cleanPurchase
})(Part4)